import { ChevronRight } from 'lucide-react';

import { StatusBadge } from '../../../ui/index.js';
import type { Tone } from '../../../ui/index.js';

export interface BuocQuyTrinh {
  nhan: string;
  so: number;
  /** Một dòng: bước này nghĩa là gì, hoặc việc cần làm để sang bước sau. */
  moTa: string;
  tone: Tone;
}

export interface ThanhQuyTrinhProps {
  buoc: BuocQuyTrinh[];
  'aria-label'?: string;
}

/**
 * Thanh quy trình **Nháp → Đã chốt → Đã thanh toán** của một kỳ đối soát.
 *
 * Thay ô "Trạng thái" trong dải chỉ số. Ô đó nhồi cả ba con số vào một giá trị
 * và một dòng ghi chú (`3 nháp` / `2 đã chốt · 1 đã trả`), nên thứ quan trọng
 * nhất của trang — *tiền đang nằm ở bước nào* — đọc ra khó hơn hai số doanh
 * thu bên cạnh nó. Ở đây ba bước nằm ngang theo đúng thứ tự chúng xảy ra, mỗi
 * bước một dòng nói nó nghĩa là gì.
 *
 * Số **0 vẫn in**: "0 nháp" là tin tốt và là câu trả lời cho "kỳ này xong
 * chưa", ẩn đi thì người dùng phải tự suy ra từ hai số còn lại.
 */
export function ThanhQuyTrinh({ buoc, 'aria-label': nhan = 'Quy trình kỳ' }: ThanhQuyTrinhProps) {
  return (
    <section
      aria-label={nhan}
      className="flex flex-col rounded-the border border-vien bg-be-mat sm:flex-row"
    >
      {buoc.map((b, i) => (
        <div
          key={b.nhan}
          className={`flex min-w-0 flex-1 items-start gap-3 px-4 py-3.5 ${
            i > 0 ? 'border-t border-vien-trong sm:border-t-0 sm:border-l sm:border-vien-trong' : ''
          }`}
        >
          {/*
            Mũi tên nằm ở **đầu** bước thứ hai trở đi, không chen giữa hai ô:
            một phần tử riêng giữa hai ô làm cột co giãn lệch nhau khi số chữ
            của ba mô tả khác nhau.
          */}
          {i > 0 && (
            <ChevronRight
              size={16}
              aria-hidden="true"
              className="mt-1.5 shrink-0 text-chu-phu max-sm:hidden"
            />
          )}

          <div className="min-w-0">
            <p className="flex flex-wrap items-center gap-2">
              <span className="so-lieu text-so-lon font-bold text-chu">{b.so}</span>
              <StatusBadge tone={b.tone}>{b.nhan}</StatusBadge>
            </p>
            <p className="mt-1 text-phu text-chu-phu">{b.moTa}</p>
          </div>
        </div>
      ))}
    </section>
  );
}
